import axios from 'axios';

import { responseError } from '../../helpers/responsePortal';
import { authHeader } from '../../helpers/authHeader';
import { getRefreshToken, setRefreshToken } from '../../helpers/authStorage';
import store from '../../redux/store';
import { logoutUser, loginUserSuccess } from '../../redux/auth/authSlice';
import history from '../../helpers/history';
import { postRefreshToken } from '../autenticacao';

const baseAxiosAuth = axios.create({
    baseURL: `${process.env.REACT_APP_ECOMMERCE_ENDPOINT}`
});

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
}


baseAxiosAuth.interceptors.request.use(
    async (config) => {
        const auth = authHeader();
        config.headers.Authorization = auth.Authorization;
        return config;
    });

baseAxiosAuth.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            const { auth } = store.getState();
            if (auth?.isLoggingOut) {
                return Promise.reject(error);
            }
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => baseAxiosAuth(originalRequest)).catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;
            const refreshToken = getRefreshToken();

            if (!refreshToken) {
                store.dispatch(logoutUser({ refreshToken: undefined, errors: undefined, navigate: undefined, history }));
                isRefreshing = false;
                return Promise.reject(error);
            }

            try {
                const result = await postRefreshToken();
                if (result?.user) {
                    setRefreshToken(result.user.refreshToken ?? null);
                    store.dispatch(loginUserSuccess({ user: result.user, navigate: undefined, location: undefined }));
                    processQueue(null, result.user.accessToken);
                    originalRequest.headers.Authorization = `Bearer ${result.user.accessToken}`;
                    return baseAxiosAuth(originalRequest);
                }
                throw new Error('Refresh failed');
            } catch (refreshError) {
                processQueue(refreshError, null);
                store.dispatch(logoutUser({ refreshToken, errors: undefined, navigate: undefined, history }));
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return responseError(error);
    }
);

export default baseAxiosAuth;